import React from 'react';
import './Hability.css';

const Hability = () => {
  const habilitiesData = {
    technical: [
      { name: 'JavaScript', percentage: 50, icon: '🟨' },
      { name: 'React', percentage: 20, icon: '⚛️' },
      { name: 'HTML & CSS', percentage: 70, icon: '🖥️' },
      { name: 'Discord.js', percentage: 65, icon: '🤖' }
    ],
    personal: [
      { name: 'Resolução de Problemas', percentage: 85, icon: '🔍' },
      { name: 'Autodidata', percentage: 60, icon: '📚' },
      { name: 'Organização', percentage: 85, icon: '🗂️' },
      { name: 'Criatividade', percentage: 60, icon: '🎨' }
    ]
  };

  return (
    <section id="Hability" className="hability-section">
      {/* Efeito de fundo verde adicionado */}
      <div className="hability-background"></div>
      
      <div className="hability-content-wrapper">
        <div className="hability-header">
          <h2 className="hability-title">Minhas <span>Habilidades</span></h2>
          <p className="hability-description">
            Conhecimentos técnicos e competências pessoais que desenvolvi em minha jornada
          </p>
        </div>

        <div className="hability-grid">
          {/* Coluna de Habilidades Técnicas */}
          <div className="hability-category">
            <div className="category-header">
              <h3>Técnicas</h3>
              <div className="decorative-line"></div>
            </div>
            <div className="hability-container">
              {habilitiesData.technical.map((hability, index) => (
                <HabilityCard 
                  key={`tech-${index}`} 
                  hability={hability} 
                  type="technical"
                />
              ))}
            </div>
          </div>

          {/* Coluna de Habilidades Pessoais */}
          <div className="hability-category">
            <div className="category-header">
              <h3>Pessoais</h3>
              <div className="decorative-line"></div>
            </div>
            <div className="hability-container">
              {habilitiesData.personal.map((hability, index) => (
                <HabilityCard 
                  key={`personal-${index}`} 
                  hability={hability} 
                  type="personal"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const HabilityCard = ({ hability, type }) => {
  const { name, percentage, icon } = hability;
  
  return (
    <div className={`hability-card ${type}`}>
      <div className="hability-icon">{icon}</div>
      <div className="hability-content">
        <h4>{name}</h4>
        <div className="hability-meta">
          <span className="hability-level">{getHabilityLevel(percentage)}</span>
          <span className="hability-percentage">{percentage}%</span>
        </div>
        <div className="hability-bar">
          <div 
            className="hability-progress" 
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

const getHabilityLevel = (percentage) => {
  if (percentage >= 80) return 'Avançado';
  if (percentage >= 50) return 'Intermediário';
  return 'Iniciante';
};

export default Hability;